export default {
  getRecommendRecipes() {
    return this.http('ExerciseCheck', 'get', '/api/v1/recipes/list');
  },
  getRecommendSports() {
    return this.http('ExerciseCheck', 'get', '/api/v1/exercises/list');
  }
};
